﻿import type { IconProps } from './../../models/icon';

export function SignIcon({
                             width = 24,
                             height = 24,
                             secondaryColor = 'rgb(var(--color-200) / 1)',
                             className = '',
                         }: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
            width={width}
            height={height}
            className={className}
        >
            <path
                fill="#fff"
                d="M5.62 12.479a2.778 2.778 0 0 0 .898-2.042 2.77 2.77 0 0 0-.898-2.042A2.786 2.786 0 0 0 3.572 7.5a2.793 2.793 0 0 0-2.048.895c-.7.698-.922 2.829-.992 4.106a.912.912 0 0 0 .967.967c1.28-.07 3.42-.29 4.121-.989Z"
            />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.62 12.479a2.778 2.778 0 0 0 .898-2.042 2.77 2.77 0 0 0-.898-2.042A2.786 2.786 0 0 0 3.572 7.5a2.793 2.793 0 0 0-2.048.895c-.7.698-.922 2.829-.992 4.106a.912.912 0 0 0 .967.967c1.28-.07 3.42-.29 4.121-.989ZM.886 13.114l2.026-2.02"
            />
            <path
                fill={secondaryColor}
                d="M12.59 1.408C11.41.23 10.074.199 8.857 1.308 7.229 2.79 4.96 6.379 4.223 7.577a2.792 2.792 0 0 1 1.397.818 2.777 2.777 0 0 1 .807 1.339c1.226-.75 4.786-2.993 6.263-4.605 1.112-1.213 1.08-2.545-.1-3.721Z"
            />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12.59 1.408C11.41.23 10.074.199 8.857 1.308 7.229 2.79 4.96 6.379 4.223 7.577a2.792 2.792 0 0 1 1.397.818 2.777 2.777 0 0 1 .807 1.339c1.226-.75 4.786-2.993 6.263-4.605 1.112-1.213 1.08-2.545-.1-3.721Z"
            />
        </svg>
    );
}